import { autoinject, bindable } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { TableHeader } from 'components/table/table-content';
import { FilterManager } from 'lib/tables/FilterManager';
import { MooringProductionOrderListItemDto } from 'models/mooring/MooringProductionOrders';

@autoinject
export class ProductionOrdersTable {
  @bindable filterManager: FilterManager;
  @bindable productionOrders: MooringProductionOrderListItemDto[] = [];

  protected tableHeaders: TableHeader<MooringProductionOrderListItemDto & { actions: '' }>[] = [
    { key: 'Id', label: 'general.id', sortable: true },
    { key: 'Created', label: 'general.created', sortable: true },
    { key: 'Customer', label: 'general.customer', sortable: true },
    { key: 'Title', label: 'general.title', sortable: true },
    { key: 'OfferTitle', label: 'generalOffer.QuoteNumber', sortable: true },
    { key: 'Contact', label: 'general.contact', sortable: true },
    { key: 'Locality', label: 'mooring.site', sortable: true },
    { key: 'LocalityNumber', label: 'mooring.siteNumber', sortable: true },
    { key: 'Status', label: 'general.status', sortable: false },
    { key: 'actions', label: '', sortable: false },
  ];

  constructor(private router: Router) {}

  protected setOrderByColumn(column: string) {
    this.filterManager.setOrderByColumn(column);
  }

  protected openProductionOrder(productionOrderId: number) {
    this.router.navigate(`mooring/production-orders/${productionOrderId}`);
  }
}
